// removed by extract-text-webpack-plugin
module.exports = {"image":"image__S_8BE","nfo-grid":"nfo-grid__26Fuu","nfo-btn":"nfo-btn__3K0WA","nfo-card":"nfo-card__3GWwa","btn-red":"btn-red__2nJVN","btn-orange":"btn-orange__2nMOG"};


//////////////////
// WEBPACK FOOTER
// ./styles/homePage/nfoSection.scss
// module id = 1190
// module chunks = 68